module.exports = __webpack_public_path__ + "img/ball.86de913a.svg";